import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../../components/layout/SiteShell";
import ContentPageLayout from "../../components/content/ContentPageLayout";
import SEO from "../../components/seo/SEO";
import ConversionCtas from "../../components/content/ConversionCtas";
import { EDITORIAL } from "../../lib/data";
import { PHOTO_BRIEF } from "../../lib/contentImagePlaceholders";

export default function GoldVsPurpleSeaMossPage() {
  const path = "/learn/gold-vs-purple-sea-moss";
  return (
    <SiteShell theme="dark">
      <SEO
        title="Gold vs purple sea moss | MossMatrix comparison"
        description="Compare MossMatrix gold and purple sea moss: smooth mild classic vs deeper colour, bold botanical profile, and higher on-site pricing as our premium base. Cards, table, and honest non-medical guidance."
        path={path}
      />
      <ContentPageLayout
        eyebrow="Learn"
        title="Gold vs purple: pick a mood, not a miracle."
        subtitle="Both are wildcrafted, spring-water gels. Gold leans smooth and everyday; purple leans bold and visual. Rotate for variety, keep it as part of a balanced lifestyle, and remember this is food, not medicine."
      >
        <div className="overflow-x-auto mb-12 rounded-2xl border border-cream bg-white">
          <table className="w-full min-w-[520px] text-sm text-left text-botanical/85">
            <thead>
              <tr className="border-b border-cream bg-offwhite text-[10px] uppercase tracking-widest text-botanical/60">
                <th className="px-4 py-3 font-medium w-1/4" />
                <th className="px-4 py-3 font-medium text-forest">Gold</th>
                <th className="px-4 py-3 font-medium text-forest">Purple</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-cream">
                <td className="px-4 py-3 font-medium text-forest">Profile</td>
                <td className="px-4 py-3">Smooth · mild · classic daily option</td>
                <td className="px-4 py-3">Deeper colour · richer natural profile · bold botanical feel</td>
              </tr>
              <tr className="border-b border-cream">
                <td className="px-4 py-3 font-medium text-forest">Kitchen vibe</td>
                <td className="px-4 py-3">Disappears into oats, mild teas, or smoothies you blend at home for the family</td>
                <td className="px-4 py-3">Shows off in berry-style herb gels, hibiscus teas, and colourful bowls you build at home</td>
              </tr>
              <tr className="border-b border-cream">
                <td className="px-4 py-3 font-medium text-forest">Pricing on site</td>
                <td className="px-4 py-3">Classic base at our entry price points for each jar size.</td>
                <td className="px-4 py-3">
                  Purple is positioned as the premium base: deeper colour, bolder profile, and higher price due to sourcing and availability.
                </td>
              </tr>
              <tr>
                <td className="px-4 py-3 font-medium text-forest">Our stance</td>
                <td className="px-4 py-3" colSpan={2}>
                  Neither base “fixes” health outcomes. Choose what you will actually enjoy spooning into your routine.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-[10px] text-botanical/50 mb-10 max-w-3xl">{PHOTO_BRIEF.jarPurpleSideBySide}</p>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="rounded-[2rem] border border-cream overflow-hidden bg-white">
            <div className="aspect-[16/10]">
              <img src={EDITORIAL.goldComposition} alt="" className="w-full h-full object-cover editorial-img" />
            </div>
            <div className="p-6">
              <h2 className="font-serif text-2xl text-forest">Gold</h2>
              <ul className="mt-3 space-y-2 text-sm text-botanical/85">
                <li>• Smooth</li>
                <li>• Mild</li>
                <li>• Classic daily option</li>
              </ul>
            </div>
          </div>
          <div className="rounded-[2rem] border border-cream overflow-hidden bg-white">
            <div className="aspect-[16/10]">
              <img src={EDITORIAL.purpleComposition} alt="" className="w-full h-full object-cover editorial-img" />
            </div>
            <div className="p-6">
              <h2 className="font-serif text-2xl text-forest">Purple</h2>
              <ul className="mt-3 space-y-2 text-sm text-botanical/85">
                <li>• Deeper colour</li>
                <li>• Richer natural profile</li>
                <li>• Bold botanical feel</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-cream bg-offwhite p-6 text-sm text-botanical/85 leading-relaxed mb-12 max-w-3xl">
          <strong className="text-forest">Rotation tip:</strong> some customers keep one jar in the fridge and freeze portions of the other purely for variety, not because one “works better.”
        </div>

        <ConversionCtas />

        <p className="text-sm text-botanical/80 text-center mt-10">
          <Link to="/learn/how-to-use-sea-moss-gel" className="underline hover:text-forest">
            How to use gel
          </Link>
          {" · "}
          <Link to="/learn" className="underline hover:text-forest">
            Learn hub
          </Link>
          {" · "}
          <Link to="/shop" className="underline hover:text-forest">
            Shop
          </Link>
          {" · "}
          <Link to="/shop" className="underline hover:text-forest">Choose your sea moss</Link>{" � "}<Link to="/mix-ins" className="underline hover:text-forest">Explore mix-in ideas</Link>
          {" · "}
          <Link to="/ingredients" className="underline hover:text-forest">
            Ingredients
          </Link>
          {" · "}
          <Link to="/faq" className="underline hover:text-forest">
            FAQ
          </Link>
        </p>
      </ContentPageLayout>
    </SiteShell>
  );
}
